import {
  BlogCategoryDetailsResponse,
  BlogCategoryListResponse,
} from "@/types/category-types";
import { withRetry } from "@/lib/utils/retry";
import { clients } from "../client";
import { WEB_ENDPOINTS } from "../endpoints";

export const getBlogCategories = async (
  page: number = 1,
  limit: number = 10,
  signal?: AbortSignal,
) => {
  return withRetry(
    () =>
      clients.golang.get<BlogCategoryListResponse>(
        WEB_ENDPOINTS.blog_category_list,
        {
          params: { page, limit },
          signal,
        },
      ),
    { signal },
  );
};
export const getTopCategories = async () => {
  return withRetry(() =>
    clients.golang.get<BlogCategoryListResponse>(
      WEB_ENDPOINTS.blog_category_top,
    ),
  );
};

export const getCategoryDetails = async (slug: string) => {
  return withRetry(() =>
    clients.golang.get<BlogCategoryDetailsResponse>(
      `${WEB_ENDPOINTS.blog_category_details}${slug}`,
    ),
  );
};
